!function() {
    const mainAddToCartButton = document.querySelector(".button--add-to-cart");
    const stickyAddToCart = document.querySelector(".sticky-add-to-cart");
    const scrollTriggers = document.querySelectorAll(".scroll-atc");

    // Move the sticky add-to-cart button to the top of the body for global availability
    document.body.prepend(stickyAddToCart);

    // Check if mainAddToCartButton exists and if we're not in Shopify design mode
    if (mainAddToCartButton && !Shopify.designMode) {
        new window.IntersectionObserver((entries) => {
            const [entry] = entries;

            if (entry.isIntersecting) {
                // Hide sticky add-to-cart when .button--add-to-cart is in view
                stickyAddToCart.classList.remove("active");
            } else {
                // Show sticky add-to-cart when .button--add-to-cart is not in view
                stickyAddToCart.classList.add("active");
            }
        }, {
            root: null, // Observe within the viewport
            rootMargin: "0px", // No margin, strict viewport boundary
            threshold: 0 // Trigger as soon as any part of the element is out of view
        }).observe(mainAddToCartButton);
    }

    // Optional: Add click event listeners for scroll triggers if needed
    if (scrollTriggers) {
        scrollTriggers.forEach((trigger) => {
            trigger.addEventListener("click", function(event) {
                let offsetTop;
                const productConverter = document.querySelector(".product-converter");
                const addToCartButton = document.querySelector(".product-converter__add-to-cart");
                const navWrapper = document.getElementById("nav-wrapper");

                const navHeight = navWrapper ? navWrapper.offsetHeight + 100 : 150;
                offsetTop = addToCartButton ? addToCartButton.offsetTop : productConverter.offsetTop;
                const scrollPosition = offsetTop - navHeight;

                window.scrollTo({
                    top: scrollPosition,
                    behavior: "smooth"
                });
            });
        });
    }
}();